<script setup lang="ts">
import type { PostRow } from '@/types/interface'
const props = defineProps({
  item: null,
  transparent: { type: Boolean, default: false },
  inline: { type: Boolean, default: false },
  layout: { default: 'line' }
})
const { t } = useI18n()
const { isLocked, isDfans, isImage, isVideo, isText } = usePost()
const { formatTime } = useOSSUploader()

const bundleBuyChooseModalRef = ref()

const BTN_TEXT = computed(() => {
  if (props.item?.price) {
    // 单价解锁
    return t('Btn.UNLOCKPRICE')
  }
  if (props.item?.subscriptionTier || props.item?.subscriptionBundle) {
    // 订阅解锁
    return t('Btn.UnlockBySubscribe')
  }
  if (props.item?.collection?.price) {
    // 合约解锁
    return t('Btn.UnlockByCollection')
  }
  return t('Btn.UNLOCKPRICE')
})
const join = () => {
  let userInfo: any = props.item
  if (props.item?.blogAuthorBO) {
    userInfo = {
      ...props.item.blogAuthorBO,
      userName: props.item.blogAuthorBO.name,
      pic: props.item.blogAuthorBO.avatar,
    }
  }
  if (props.item?.subscriptionBundle) {
    bundleBuyChooseModalRef.value.open({
      buyInfo: {
        ...props.item,
        priceDollar: props.item?.subscriptionBundle?.baseAmount,
        id: props.item?.subscriptionBundle?.id,
      },
      userInfo,
      type: 'subscribeBundle',
      subscriptionBundles: props.item?.subscriptionBundle,
    })
  } else {
    GlobalThis.$buyModal.open({
      postInfo: props.item,
      isPreview: true,
      type: 'post',
      userInfo,
      eventType: 'post_list_buy_btn',
    })
  }
}
defineExpose({ join })
</script>

<template>
  <div
    v-if="isLocked(item) && !isDfans(item) && props.layout === 'line'"
    v-auth="{ clickHandler: join }"
    :attr-domain="item?.blogAuthorBO?.domain"
    class="flex flex-col justify-center items-center"
    :class="{
      '!bg-transparent !bg-none': props.transparent,
      'absolute-full': props.inline,
      'h-66 ': !props.inline,
    }"
  >
    <div
      class="absolute-full z-2 flex flex-col items-center justify-center p-4 bg-black bg-op-25 backdrop-blur-40px"
    >
      <div class="w-full flex-1 flex items-center justify-center">
        <img
          v-if="isText(item)"
          class="w-full h-full absolute left-0 top-0 object-cover -z-1"
          src="@/assets/image/post/Group.png"
          alt="dfans"
        />
        <div class="w-12 h-12 rounded-full flex justify-center items-center bg-black bg-op-40">
          <img src="@/assets/image/feed/lock1.png" class="w-5 h-5" alt="dfans" />
        </div>
      </div>

      <div
        class="rounded-2 p-3.5 pb-4 w-full b-1 b-white b-op-40 bg-transparent bg-op-10 bg-black backdrop-blur-40px"
      >
        <div class="flex justify-between items-center text-white">
          <div class="flex items-center">
            <div v-if="isImage(item)" class="flex items-center mr-1.5">
              <div i-material-symbols:image-outline class="w-4.5 h-4.5 text-white" />
              <span class="ml-0.5 text-3.25 leading-4.5">
                {{ item.media?.length || 1 }}
              </span>
            </div>
            <div
              v-if="isVideo(item) && item?.media && item?.media[0]?.duration"
              class="flex items-center"
            >
              <div i-material-symbols:videocam-outline class="w-4.5 h-4.5 text-white" />
              <span
                class="text-3.25 leading-4.5"
                :class="item?.media[0]?.duration ? 'ml-1' : 'ml-0.5'"
              >
                {{ formatTime(item?.media[0]?.duration) }}
              </span>
            </div>
          </div>
        </div>
        <DfansButton
          :text="BTN_TEXT"
          class="sm:mt-3 mt-2.5 w-full !min-h-9 py-1.5 !text-3.5 flex items-center"
          type="default"
          @click="join"
        />
      </div>
    </div>
  </div>
  <div
    v-if="isLocked(item) && !isDfans(item) && props.layout === 'grid'"
    v-auth="{ clickHandler: join }"
    class="lock-view flex flex-col justify-center items-center"
    :class="{
      '!bg-transparent !bg-none': props.transparent,
      'absolute-full': props.inline,
      'h-66 ': !props.inline,
    }"
  >
    <div class="w-12 h-12 rounded-full flex justify-center items-center bg-black bg-op-40">
      <img src="@/assets/image/feed/lock1.png" class="w-5 h-5" alt="dfans" />
    </div>
    <DfansButton
      :text="t('Post.UnlockNow')"
      class="h-9 !mt-4"
      type="default"
      :class="`${layout === 'line' ? 'block' : 'hidden sm:block'}`"
    />
  </div>

  <!-- 选择buddle价格 -->
  <BundleBuyChooseModal
    ref="bundleBuyChooseModalRef"
    :subscription-bundles="item.subscriptionBundle"
  />
</template>

<style lang="less">
.lock-view {
  background: url('@/assets/image/feed/bg-lock.png') no-repeat center/cover;
}
</style>
